import React, { useState, useContext } from 'react';
import s from '../styles/CreateProjectModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faSquarePlus } from '@fortawesome/free-solid-svg-icons';
import { ProjectContext } from '../ProjectContext';
import CategoryTree from './CategoryTree';
import { useNavigate } from 'react-router-dom';
import CheckPagesModal from './CheckPagesModal';



const CreateProjectModal = ({user_id ,onClose, onCreate }) => {
const navigate = useNavigate();
const { fetchProjects } = useContext(ProjectContext);
const [showTemplateModal, setShowTemplateModal] = useState(false);
const [showCheckPagesModal, setCheckPagesModal] = useState(false);

  const [formData, setFormData] = useState({
    table_name: '',
    yandex_token: '',
    avito_client_id: '',
    avito_client_secret: '',
    google_table: '',
    used_pages: '',
    user_id
  });

  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreate = async () => {
    setIsSaving(true);
    setError(null);
    setSuccess(false);
    try {
      const response = await fetch('/api/projects/create_project', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || `Ошибка ${response.status}`);
      }

      onCreate(result.project);
      setSuccess(true);
      onClose(); // можно оставить задержку, если нужно
      fetchProjects(user_id);
      // navigate("/dashboard?tab=projects")
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={s.modalOverlay}>
      <div className={s.modalContent}>
        <h2 className={s.modal_h2}>Создание проекта</h2>
        <button onClick={onClose} className={s.close}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>
        {error && <div style={{ color: 'red' }}>{error}</div>}
        {success && <div style={{ color: 'green' }}>✅ Проект создан</div>}

        {[
          ['Название проекта', 'project_name', null],
          ['Yandex Token', 'yandex_token', 'https://oauth.yandex.ru/authorize?response_type=token&client_id=7bc0bf0e286d46f59ee384d2bc06fbde'],
          ['Avito Client ID', 'avito_client_id', 'https://www.avito.ru/professionals/api'],
          ['Avito Client Secret', 'avito_client_secret', 'https://www.avito.ru/professionals/api'],
          ['Ссылка на Google Таблицу', 'google_table', null],
          ['Активные листы', 'used_pages', null]
        ].map(([label, name, href]) => (
          <div className={s.one_input_row} key={name}>
            <div className={s.formGroup}>
              <label className={s.edit_label}>{label}</label>
              <input
                className={s.edit_input}
                name={name}
                value={formData[name]}
                onChange={handleChange}
              />
              {href && (
                <a className={s.href_buttons} target="_blank" rel="noreferrer" href={href}>
                  <FontAwesomeIcon icon={faSquarePlus} />
                </a>
              )}
            </div>
          </div>
        ))}
         {/* Кнопка для открытия выбора шаблона */}
         <div className={s.excel_template_buttons_div}>
            <button
              className={s.excelUploadBtn}
              disabled={!formData.google_table.startsWith("https://")}
              onClick={() => setShowTemplateModal(true)}
            >
              Добавить шаблон
            </button>
            <button
              className={s.excelUploadBtn}
              onClick={() => setCheckPagesModal(true)}
              disabled={!formData.google_table.startsWith("https://")}
            >
              Проверить Листы
            </button>
          </div>

        <div className={s.buttonGroup}>
          <button onClick={handleCreate} disabled={isSaving}>
            {isSaving ? 'Создание...' : 'Создать'}
          </button>
          <button onClick={onClose} className={s.cancel}>
            Отмена
          </button>
        </div>
        {showTemplateModal && (
          <CategoryTree
            projectHref={formData.google_table}
            onClose={() => setShowTemplateModal(false)}
          />  
        )}

        {showCheckPagesModal && (
          <CheckPagesModal
            googleId={formData.google_table}
            projectId={formData.used_pages}
            onClose={() => setCheckPagesModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default CreateProjectModal;
